<sui-dialog-tabs [(error)]="apiError">
  <ng-template suiDialogLeftHeader>
    @if (actionIcon) {
      <fa-icon [icon]="actionIcon"></fa-icon>
    }
    <h2 ngpDialogTitle>{{ actionTitle }}</h2>
  </ng-template>

  <ng-template suiDialogLeftContent>
    <!-- ⚠️ Portal - Tabs -->
    <ng-container [cdkPortalOutlet]="tabsPortal"></ng-container>
  </ng-template>

  <ng-template suiDialogRightHeader>
    <div class="right-header-content">
      @if (objectIcon) {
        <fa-icon [icon]="objectIcon"></fa-icon>
      }
      <h2 ngpDialogDescription>{{ objectTitle }}</h2>
    </div>

    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancelAction()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogRightContent>
    <!-- ⚠️ Portal - Form -->
    <ng-container [cdkPortalOutlet]="formPortal"></ng-container>
  </ng-template>

  <ng-template suiDialogRightFooter>
    <sui-button
      size="md"
      variant="secondary"
      [leadingIcon]="['fas', 'times']"
      (click)="cancel()"
    >
      {{ "btn.cancel" | translate }}
    </sui-button>

    <sui-button
      size="md"
      variant="primary"
      [leadingIcon]="['fas', 'save']"
      [loading]="saving()"
      (click)="save()"
    >
      {{ "btn.save" | translate }}
    </sui-button>
  </ng-template>
</sui-dialog-tabs>

<!-- ❌ Important: we have to init the Component - no issues with duplication -->
<app-editor-user-group
  #editorUserGroup
  [userGroup]="userGroup"
  [isPopup]="true"
  (cancelled)="cancelAction()"
  style="display: none"
></app-editor-user-group>
